import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { companyAPI } from '../utils/api';
import { Target, Eye, Calendar, Users, Award } from 'lucide-react';
import Seo from '../components/Seo';

const AboutPage = () => {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    fetchCompanyInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCompanyInfo = async () => {
    try {
      const response = await companyAPI.getInfo();
      setCompanyInfo(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Seo
        pageKey="about"
        seo={companyInfo?.seo}
        defaults={{
          title: 'About Ecoway Cabs | Trusted Transportation Partner Since 2012',
          description: 'Learn about Ecoway Cabs — our mission, vision, and 13+ years of delivering safe, punctual corporate and intercity transportation for 50+ MNCs across India.',
          keywords: 'about Ecoway Cabs, transportation company India, corporate cab provider, our mission, fleet operator',
        }}
        path="/about"
      />
      <section className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4">About Ecoway Cabs</h1>
          <p className="text-xl text-blue-100">{companyInfo?.about_subtitle || 'Your trusted transportation partner since 2012'}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-lg text-gray-700 leading-relaxed">{companyInfo?.about}</p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <Card>
              <CardContent className="p-8">
                <div className="bg-blue-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                  <Target className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
                <p className="text-gray-700 leading-relaxed">{companyInfo?.mission}</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <div className="bg-green-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                  <Eye className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
                <p className="text-gray-700 leading-relaxed">{companyInfo?.vision}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Why Businesses Trust Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card>
              <CardContent className="p-6 text-center">
                <Calendar className="h-12 w-12 text-blue-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Established {companyInfo?.established_year}</h3>
                <p className="text-gray-600">{companyInfo?.trust_established_desc || 'Over a decade of reliable service'}</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <Users className="h-12 w-12 text-green-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">{companyInfo?.trust_clients_title || '50+ Corporate Clients'}</h3>
                <p className="text-gray-600">{companyInfo?.trust_clients_desc || 'Trusted by leading MNCs'}</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <Award className="h-12 w-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">{companyInfo?.trust_presence_title || 'Pan-India Presence'}</h3>
                <p className="text-gray-600">{companyInfo?.trust_presence_desc || 'Serving 100+ cities nationwide'}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
